import { useEffect, useRef, useState } from "react";
import { useConnect, useConnectors } from "wagmi";
import { Button } from "../components/ui";

/** Connects an injected wallet: straight to it when there is one, a short list when there are more. */
export function ConnectButton({ size = "md", block = false, label = "Connect" }: { size?: "sm" | "md" | "lg"; block?: boolean; label?: string }) {
  const connectors = useConnectors();
  const { mutate: connect, isPending } = useConnect();
  const [picking, setPicking] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const announced = connectors.filter((connector) => connector.id !== "injected");
  const choices = announced.length > 0 ? announced : connectors;

  useEffect(() => {
    if (!picking) return;
    const close = (event: MouseEvent) => {
      if (!ref.current?.contains(event.target as Node)) setPicking(false);
    };
    window.addEventListener("mousedown", close);
    return () => window.removeEventListener("mousedown", close);
  }, [picking]);

  return (
    <div className={`connect-wrap ${block ? "connect-block" : ""}`} ref={ref}>
      <Button
        tone="primary"
        size={size}
        block={block}
        busy={isPending}
        onClick={() => {
          const only = choices[0];
          if (choices.length === 1 && only) connect({ connector: only });
          else setPicking((open) => !open);
        }}
      >
        {isPending ? "Connecting" : label}
      </Button>
      {picking && (
        <ul className="wallet-menu" role="menu">
          {choices.length === 0 && (
            <li className="wallet-menu-empty">
              No browser wallet found. Install one such as Rabby or MetaMask, then reload.
            </li>
          )}
          {choices.map((connector) => (
            <li key={connector.uid}>
              <button
                type="button"
                role="menuitem"
                onClick={() => {
                  setPicking(false);
                  connect({ connector });
                }}
              >
                {connector.icon ? <img src={connector.icon} alt="" width={20} height={20} /> : <span className="wallet-blank" />}
                {connector.name}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
